var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "map", attrs: { id: "chart-map" } },
    [
      _vm.showLayerSwitcher
        ? _c("layer-switcher-component", {
            staticClass: "chart-lsw",
            attrs: {
              activeLayer: _vm.activeBaseLayerId,
              onChange: _vm.changeBaseLayer,
              layers: _vm.$conf.chart.layers,
              position: "is-bottom-left"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.dates.indexOf(_vm.date) > 0
        ? _c(
            "a",
            {
              staticClass: "rotate prev",
              attrs: { href: "#" },
              on: {
                click: function(e) {
                  return _vm.prevDate(e)
                }
              }
            },
            [
              _c("b-icon", {
                attrs: {
                  icon: "chevron-left-circle",
                  type: "is-black",
                  size: "is-large"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.dates.indexOf(_vm.date) < _vm.dates.length - 1
        ? _c(
            "a",
            {
              staticClass: "rotate next",
              attrs: { href: "#" },
              on: {
                click: function(e) {
                  return _vm.nextDate(e)
                }
              }
            },
            [
              _c("b-icon", {
                attrs: {
                  icon: "chevron-right-circle",
                  type: "is-black",
                  size: "is-large"
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }